export type vocab = {
    genreId: number & { _vocabGenreId: never };
    vocabId: number;
    hiragana: string;
    kanji: string;
    english: string;
    order: number;
    audioExtension: string;
    audioVersion: number;
    enAudioExtension: string;
    enAudioVersion: number;
};
export type vocabGenre = {
    genreId: number & { _vocabGenreId: never };
    genreName: string;
    order: number;
    youtube: string;
    youtubeSpecial: string;
    released: boolean;
    fallingAnimation: string;
    hasAudio: boolean;
    hasProductAudio: boolean;
};
export function VocabGenreId(id: number) {
    return id as vocabGenre["genreId"];
}
export type vocabMergedGenre = {
    genreId: number & { _mergedVocabGenreId: never };
    genreName: string;
    order: number;
    youtube: string;
    released: boolean;
};
export function VocabMergedGenreId(id: number) {
    return id as vocabMergedGenre["genreId"];
}
export type sound = {
    audio: HTMLAudioElement;
    playable: boolean;
};
export type VocabFilterWord =
    | "JLPT_N5"
    | "JLPT_N4"
    | "JLPT_N3"
    | "JLPT_N2"
    | "JLPT_N1"
    | "Other";
